import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

const SelectComponent = ({ name,label, items, value, change, error, gridColumn, gridRow, disabled = false, required }) => {
  const { t } = useTranslation();
  const labelText = label !=="" ? label : name;
  return (
    <FormControl
      variant="filled"
      fullWidth
      sx={{ gridColumn: gridColumn, gridRow: gridRow }}
    >
      <InputLabel id={name} required={required}>{t("fields.selectOne", { label: labelText })}</InputLabel>
      <Select
        name={name}
        labelId={name}
        id={name}
        value={value}
        label={labelText}
        onChange={change}
        disabled={disabled}
        sx={{ gridColumn: "span 1" }}
      >
        {items.map((item) => (
          <MenuItem
            key={item._id}
            value={item._id}
            onClick={(e) => {
              if (value === item._id) {
                e.preventDefault();
                change({
                  target: {
                    name: labelText,
                    value: "",
                  },
                });
              }
            }}
            sx={{
              opacity: value === item._id ? 1 : 0.5,
              backgroundColor:
                value === item._id ? "black !important" : "transparent",
              color: value === item._id ? "white" : "inherit",
            }}
          >
            {item.labelKey ? t(item.labelKey) : item.name}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <FormHelperText sx={{ color: "red", mt: "8px", fontSize: "14px" }}>
          {t("fields.selectOneError", { label: labelText })}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectComponent;
